import { Component, inject, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { GungNotificationService } from 'gung-common';
import { ConfigurationsService } from '../../services/configurations.service';
import { SepaSafeguardService } from '../../services/sepa-safeguard/sepa-safeguard.service';
import { DryRunResult, SafeguardConfig } from '../../models/sepa-safeguard';

@Component({
  selector: 'lib-sepa-safeguard-config',
  standalone: false,
  templateUrl: './sepa-safeguard-config.component.html',
  styleUrl: './sepa-safeguard-config.component.scss'
})
export class SepaSafeguardConfigComponent implements OnInit {
  protected configurationsService = inject(ConfigurationsService);
  protected gungNotificationService = inject(GungNotificationService);
  protected translateService = inject(TranslateService);
  protected sepaSafeguardService = inject(SepaSafeguardService);

  configuration: SafeguardConfig;
  loaded = false;

  dryRunResult: DryRunResult | null = null;
  dryRunLoading = false;

  ngOnInit(): void {
    this.configurationsService.getConfigurationsByIds(['SepaDirectDebitSafeguardConfig'], true).subscribe(configs => {
      if (!configs || configs.length === 0) {
        this.configuration = {
          '@class': 'io.gung.module.feature.sepa_direct_debit.configurations.SepaDirectDebitSafeguardConfig',
          id: 'SepaDirectDebitSafeguardConfig',
          enabled: true,
          maxPaymentCountPerRun: 50,
          maxTotalAmountPerRun: 100000,
          maxSinglePaymentAmount: 10000,
          anomalyDetectionEnabled: true,
          anomalyMultiplier: 2.0,
          anomalyLookbackRuns: 10,
          maxDailyAmount: 200000,
          maxWeeklyAmount: 500000,
          overrideValidityMinutes: 120
        };
      } else {
        this.configuration = configs[0] as SafeguardConfig;
      }
      this.loaded = true;
    });
  }

  save(): void {
    this.configurationsService.updateConfiguration(this.configuration).subscribe({
      next: () => {
        this.gungNotificationService.notify(
          this.translateService.instant('SAFEGUARD_CONFIG_SAVED'),
          null,
          'success'
        );
      },
      error: err => {
        const message = err?.error?.message || this.translateService.instant('ERROR_SAVING_SAFEGUARD_CONFIG');
        this.gungNotificationService.notify(message, null, 'danger');
      }
    });
  }

  runDryRun(): void {
    this.dryRunLoading = true;
    this.dryRunResult = null;
    this.sepaSafeguardService.dryRun().subscribe({
      next: result => {
        this.dryRunResult = result;
        this.dryRunLoading = false;
      },
      error: err => {
        const message = err?.error?.message || this.translateService.instant('ERROR_RUNNING_DRY_RUN');
        this.gungNotificationService.notify(message, null, 'danger');
        this.dryRunLoading = false;
      }
    });
  }
}
